import React, { Component } from 'react';
import img from '../../../assets/Broker/BrokerEnrollments_Content/f606478923a4ba7f25c841e13769f387_html_9c51db1c2ef9b5e7.png';
class BrokerEnrollmentsContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Broker Enrollment:</b></p>
                <p>Broker can view members enrolled in application in Our Enrollment menu, Broker can view members enrolled under him. Enrollments are uploaded to system by broker through enrollment file upload.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default BrokerEnrollmentsContent;
